

export default function Spinner(): JSX.Element {
    return (
        <div className='wrapper-spinner'>
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
}